/** Centralized TanStack Query keys for cache invalidation. */
export const qk = {
  me: ["me"] as const,
  tables: ["tables"] as const,
  table: (schema: string, name: string) => ["table", schema, name] as const,
  rows: (schema: string, name: string, params: unknown) =>
    ["rows", schema, name, params] as const,
};

export function encodePk(pk: Record<string, unknown>): string {
  return Object.entries(pk)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    .join(";");
}
